import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { shortcutLabel } from "@/lib/hotkeys";

const GROUPS: { title: string; items: [string, string][] }[] = [
  {
    title: "Anywhere",
    items: [
      ["mod+k", "Command menu and search"],
      ["c", "New issue"],
      ["/", "Formatting menu while writing; search elsewhere"],
      ["g h", "Go to home"],
      ["g i", "Go to inbox"],
      ["g m", "Go to my work"],
      ["g t", "Go to stickies"],
      ["g p", "Go to projects"],
      ["g r", "Go to roadmap"],
      ["g d", "Go to idea shelf"],
      ["mod+[", "Show or hide sidebar"],
      ["shift+?", "This list"],
    ],
  },
  {
    title: "Issue lists and boards",
    items: [
      ["j", "Next issue"],
      ["k", "Previous issue"],
      ["x", "Select issue"],
      ["shift+j", "Extend selection"],
      ["enter", "Open issue"],
      ["escape", "Clear selection"],
    ],
  },
  {
    title: "On the focused or selected issues",
    items: [
      ["s", "Change status"],
      ["p", "Set priority"],
      ["a", "Assign"],
      ["i", "Assign to me"],
      ["l", "Labels"],
      ["shift+p", "Move to project"],
      ["shift+c", "Move to cycle"],
      ["e", "Estimate"],
      ["shift+d", "Due date"],
    ],
  },
];

export function ShortcutsHelp({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>Shortcuts don't fire while you're typing in a field.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-6 sm:grid-cols-2">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <div className="mb-2 text-xs font-medium text-muted-foreground">{g.title}</div>
              <div className="flex flex-col gap-1">
                {g.items.map(([k, label]) => (
                  <div key={k} className="flex items-center justify-between text-[13px]">
                    <span>{label}</span>
                    <span className="flex gap-1">
                      {k.split(" ").map((part) => (
                        <kbd key={part} className="min-w-6 rounded border bg-muted px-1.5 py-0.5 text-center font-mono text-[11px] text-muted-foreground">
                          {shortcutLabel(part)}
                        </kbd>
                      ))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
